import React, { useState } from "react";
import { Image } from "./image";
import { Modal } from "./modal";

export const Physiotherapy = ({ data = [] }) => {
  const [activeIndex, setActiveIndex] = useState(null);
  const activeItem = activeIndex !== null ? data[activeIndex] : null;

  return (
    <div id="physiotherapy" className="text-center">
      <div className="container" style={{ display: "flex", flexDirection: "column", alignItems: "center"}}>
        <div className="section-title">
          <h2>Mais Sobre Fisioterapia</h2>
          <p>
            Conheça em mais detalhe quais as modalidades terapêuticas na àrea de fisioterapia.
          </p>
        </div>

        <div className="row" style={{ width: "80%", maxWidth: "1100px" }}>
          <div className="portfolio-items">
            {data.length
              ? data.map((d, i) => (
                  <div
                    key={`${d.title}-${i}`}
                    className="col-sm-6 col-md-4 col-lg-4"
                  >
                    <Image
                      title={d.title}
                      smallImage={d.smallImage}
                      onClick={() => setActiveIndex(i)}
                    />
                  </div>
                ))
              : "Loading..."}
          </div>
        </div>
      </div>

      <Modal
        isOpen={activeIndex !== null}
        onClose={() => setActiveIndex(null)}
        item={activeItem}
      />
    </div>
  );
};
